import { Stack } from '@mui/material';
import { FlowDurationUnits, FlowHieDocumentFormat } from 'flow-schema';

import { HIE_GET_DOCUMENTS_FORMAT_VARIANTS } from './Variants';
import { BlockDurationField } from '../../ConfigFields/Duration';
import { BlockSelectField, ParentBlockSelectField } from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

const PATIENT_SOURCE_HELPER_TEXT = `Select which upstream block to pull Patient HIE ID from.`;

const DOCUMENT_FORMAT_OPTIONS = [
  { value: FlowHieDocumentFormat.ConsolidatedData, label: 'FHIR Format (JSON)' },
  { value: FlowHieDocumentFormat.ConsolidatedDataPdf, label: 'FHIR Format (PDF)' },
  { value: FlowHieDocumentFormat.ConsolidatedDataHtml, label: 'FHIR Format (HTML)' },
  { value: FlowHieDocumentFormat.BulkDownloadUrls, label: 'PDF, HTML' },
];

export function HieGetDocumentsFormFields() {
  const { value: documentFormat } =
    useSelectedNodeField<FlowHieDocumentFormat>('config.documentFormat');
  const { Config } = (documentFormat
    ? HIE_GET_DOCUMENTS_FORMAT_VARIANTS[documentFormat]
    : null) ?? {
    Config: null,
  };

  return (
    <Stack spacing={2}>
      <ParentBlockSelectField
        fieldName="config.sourceBlock.sourceBlockName"
        label="HIE Query Source"
        required
        helperText={PATIENT_SOURCE_HELPER_TEXT}
      />
      <BlockSelectField
        fieldName="config.documentFormat"
        label="Document Format"
        required
        options={DOCUMENT_FORMAT_OPTIONS}
      />
      {Config && <Config />}
      <BlockDurationField
        fieldName="config.timeout"
        unitFieldNameSuffix="units"
        required={true}
        allowedUnits={[
          FlowDurationUnits.Hours,
          FlowDurationUnits.Minutes,
          FlowDurationUnits.Seconds,
        ]}
        toggleLabel="Timeout"
        valueLabel="Timeout (fail after duration)"
        valueHelperText="Will fail if block does not complete after duration"
      />
    </Stack>
  );
}
